import { render, staticRenderFns } from "./TabGroupRouted.vue?vue&type=template&id=2a88fb70&scoped=true"
import script from "./TabGroupRouted.vue?vue&type=script&lang=ts"
export * from "./TabGroupRouted.vue?vue&type=script&lang=ts"
import style0 from "./TabGroupRouted.vue?vue&type=style&index=0&id=2a88fb70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a88fb70",
  null
  
)

export default component.exports